<template>
    <div class="chageOrderInfo">
        <!-- 修改订单信息 -->
        <Customer-Order :showProListCopy.sync="showProListCopy" @updataItem="updataItem(arguments)"></Customer-Order>
        <div class="chageOrderInfo_top">
            <div>{{ $t('other.a241') }}</div>
            <div class="btn">
                <div class="btn_item"><el-button size="medium" type="primary" @click="addItem()">{{ $t('other.a603')
                }}</el-button></div>
                <div class="btn_item"><el-button size="medium" type="primary" @click="reset()">{{ $t('other.a604')
                }}</el-button></div>
                <div class="btn_item"><el-button size="medium" type="danger" @click="saveItem()">{{ $t('other.a216')
                }}</el-button></div>
                <div class="btn_item"><el-button size="medium" type="primary" @click="back()">{{ $t('other.a605')
                }}</el-button></div>
            </div>
        </div>
        <div class="order_info">{{ $t('other.a87') }}{{ orderInfo.orderId }}</div>
        <div class="receiptInfo">
            <div class="desc_title">{{ $t('other.a613') }}</div>
            <el-form class="vjhkbnv" ref="form" :model="orderInfo" :rules="rules" label-width="120px">
                <div style="display:flex;margin-bottom:20px">
                    <el-form-item :label="$t('other.a518') + ':'" prop="address.name">
                        <el-input v-model="orderInfo.address.name"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('other.a519') + ':'" prop="address.phone">
                        <el-input v-model="orderInfo.address.phone"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('other.a626') + ':'">
                        <el-input v-model="orderInfo.address.zipCode"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('other.a481') + ':'" prop="country">
                        <el-select v-model="orderInfo.country" :placeholder="$t('other.a627')">
                            <el-option v-for="item in options" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>

                    </el-form-item>
                </div>
                <div style="display:flex">
                    <el-form-item :label="$t('other.a628') + ':'" prop="address.state">
                        <el-input v-model="orderInfo.address.state"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('other.a629') + ':'" prop="address.city">
                        <el-input v-model="orderInfo.address.city"></el-input>
                    </el-form-item>
                    <!-- <el-form-item :label="$t('other.a628')+':'" prop="address.city">
                    <el-input v-model="orderInfo.address.city"></el-input>
                </el-form-item>
                <el-form-item :label="$t('other.a629')+':'" prop="address.state">
                    <el-input v-model="orderInfo.address.state"></el-input>
                </el-form-item> -->
                    <el-form-item :label="$t('other.a630') + ':'" style="width:100%" prop="address.fullAddress">
                        <el-input v-model="orderInfo.address.fullAddress"></el-input>
                    </el-form-item>

                </div>


            </el-form>
        </div>
        <div class="table">
            <el-table border :data="orderInfo.items">
                <el-table-column label="Img">
                    <template slot-scope="scope">
                        <div class="picbox"><img style="width:100%"
                                :src="scope.row.attributeImage ? scope.row.attributeImage : scope.row.image" @click="openImg(orderInfo,scope.row,scope.$index)" /></div>
                    </template>
                </el-table-column>
                <el-table-column label="itemsku" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        {{ scope.row.itemSku ? scope.row.itemSku : $t('other.a260') }}
                    </template>
                </el-table-column>
                <el-table-column label="variationSku">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.itemKey" @change="bvjnf(scope.$index)"
                            :placeholder="$t('other.a50')">
                            <el-option v-for="item in scope.row.variationsCopy" :key="item.itemKey"
                                :label="item.variationSku" :value="item.itemKey">
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column label="purchaseNum" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <el-input-number @change="vkgbvm()" v-model="scope.row.variationQuantityPurchased"
                            :min="1"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('other.a606')">
                    <template slot-scope="scope">
                        <!-- {{scope.row.variationSkuNum}} -->
                        <div v-for="(item, index) in scope.row.variationsCopy" :key="index"
                            v-if="scope.row.variationSku == item.variationSku">
                            {{ item.storeNum }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="280px" label="operate">
                    <template slot-scope="scope">
                        <el-button style="width:110px;" size="mini" type="primary"
                            @click="changeItem(scope.row, scope.$index)">{{ $t('other.a607') }}</el-button>
                        <el-button style="width:110px;" size="mini" type="info" @click="deleteItems(scope.$index)">{{
                            $t('other.a312') }}</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="receiptInfo" v-if="orderInfo.platform == 'DXS' || orderInfo.platform == 'EXCEL'">
            <div class="desc_title">
                <span>{{ $t('other.a85') }}</span>
            </div>
            <div style="margin-top:20px">
                <span class="vbknv">{{ $t('other.a615') }}：{{ Bulky }} /KG</span>
                <span class="vbknv">{{ $t('other.a616') }}：{{ totalWeight }} /KG</span>
                <span class="vbknv">{{ $t('other.a617') }}：{{ DxsObjParams.storeId }}</span>
                <span class="vbknv">{{ $t('other.a618') }}：{{ totaFee }} {{ $t('other.a54') }}</span>
            </div>
            <div style="margin-top:20px;display:flex;align-items: center;">
                <div style="margin-right: 20px;">
                    选择尾程快递方式:
                </div>
                <el-select v-model="orderInfo.logistics" clearable>
                    <el-option label="USPS" value="USPS">
                    </el-option>
                    <el-option label="FedEx" value="FedEx">
                    </el-option>
                    <el-option label="UPS" value="UPS">
                    </el-option>
                    <el-option label="UniUni" value="UniUni">
                    </el-option>
                    <el-option label="GOFO" value="GOFO">
                    </el-option>
                    <el-option label="其他物流" value="其他物流">
                    </el-option>
                </el-select>
            </div>
            <div style="margin-top:20px;display:flex;align-items: center;">
                <div style="margin-right: 20px;white-space: nowrap;">
                    运单号:
                </div>
                <el-input style="width: 300px;" placeholder="请输入准确运单号" v-model="orderInfo.trackingNo"></el-input>
            </div>
            <div style="margin-top:20px;display:flex;align-items: center;">
                <div style="margin-right: 20px;">
                    选择面单:
                </div>
                <el-upload class="upload-demo" action="https://erp.shopsbu.com/service/access/upload/label"
                    :on-preview="handlePreview" :on-remove="handleRemove" :on-success="handleSuccess"
                    :headers="importHeaders" :before-remove="beforeRemove" :limit="1" :on-exceed="handleExceed"
                    :file-list="fileList">
                    <el-button size="small" type="primary">{{ $t('other.a368') }}</el-button>
                </el-upload>
            </div>
        </div>
        <div class="receiptInfo" v-if="orderInfo.platform == 'DXS' || orderInfo.platform == 'EXCEL'">
            <div class="desc_title">
                <span>{{ $t('other.a624') }}</span>
            </div>
            <div style="margin-top:20px">
                <div>
                    <el-input type="textarea" :rows="2" :placeholder="$t('other.a625')" v-model="orderInfo.msgToStore">
                    </el-input>
                </div>
            </div>

        </div>
        <!-- 更新图片 -->
        <el-dialog :title="$t('other.a294')" :close-on-click-modal="false" :visible.sync="updatPicShow" width="30%">
            <div style="text-align: center">
                <el-upload class="avatar-uploader" action="https://erp.shopsbu.com/service/access/upload"
                    :show-file-list="false" :headers="token"
                    :on-success="(res, file) => handleFileSuccess(ttp, res, file)">
                    <img v-if="updatPic.image" :src="updatPic.image" class="avatar">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="imgCancel()">{{ $t('other.a106')
                }}</el-button>
                <el-button type="primary" @click="imgConfirm()">{{ $t('other.a279') }}</el-button>
            </span>
        </el-dialog>


    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import newOrder from '../../../../api/moudles/newOrders'
import CustomerOrder from '../components/dialog'
import utils from '@/utils/utils'
import galleryApi from '@/api/moudles/gallery'
export default {
    data() {
        return {

            showProListCopy: false,
            arr: null,
            changeIndex: null,
            orderInfo: null,
            originData: null,
            rules: {
                'address.name': [
                    { required: true, message: this.$t('other.a638'), trigger: 'blur' },
                ],
                'address.city': [
                    { required: true, message: this.$t('other.a639'), trigger: 'blur' },
                ],
                'address.phone': [
                    { required: true, message: this.$t('other.a640'), trigger: 'blur' },
                ],
                'address.state': [
                    { required: true, message: this.$t('other.a641'), trigger: 'blur' },
                ],
                'address.town': [
                    { required: true, message: this.$t('other.a642'), trigger: 'blur' },
                ],
                'address.fullAddress': [
                    { required: true, message: this.$t('other.a643'), trigger: 'blur' },
                ],
                country: [
                    { required: true, message: this.$t('other.a644'), trigger: 'blur' },
                ],
            },
            options: [{
                label: this.$t('chat.Thailand'),
                value: 'TH',
            }, {
                label: this.$t('h5.DSX_index_my'),
                value: 'MY',
            }, {
                label: this.$t('h5.DSX_index_ph'),
                value: 'PH',
            }, {
                label: this.$t('h5.DSX_index_vn'),
                value: 'VN',
            }, {
                label: this.$t('chat.Singapore'),
                value: 'SG',
            }, {
                label: this.$t('chat.Indonesia'),
                value: 'ID',
            }],


            DxsObjParams: {
                height: null,
                length: null,
                orderId: null,
                shopId: null,
                storeId: null,
                userId: null,
                weight: null,
                width: null,
                ruleId: null,
                totalVlumn: 0,
                totalWeight: 0
            },
            newObj: {
                firstFee: 0,
                firstWeight: 0,
                weightFee: 0,
                type: 0
            },
            importHeaders: { token: JSON.parse(localStorage.getItem('userInfo')).token },
            fileList: [],

            updatPic: {
                orderId: '',
                orderSn: '',
                itemKey: '',
                image: '',
            },
            updatPicShow: false,
            token: {
                token: JSON.parse(localStorage.getItem('userInfo')).token
            },
            updatPicIndex:0,
        }
    },
    computed: {
        ...mapState({
            userId: state => state.shopaccess.userInfo.userId,
            // orderInfo: state => state.common.orderInfo,
            // originData: state => state.common.originData,

        }),
        Bulky() {//体积重
            return this.DxsObjParams.totalVlumn
        },

        totalWeight() {//重量
            return this.DxsObjParams.totalWeight
        },

        totaFee() {
            let ttp = 0
            if (this.newObj.type == 0) {
                if (this.DxsObjParams.totalWeight <= this.newObj.firstWeight) {
                    ttp = this.newObj.firstFee
                } else {
                    ttp = (this.DxsObjParams.totalWeight - this.newObj.firstWeight) * this.newObj.weightFee + this.newObj.firstFee
                }

            } else if (this.newObj.type == 1) {
                if (this.DxsObjParams.totalVlumn / 6000 <= this.newObj.firstWeight) {
                    ttp = this.newObj.firstFee
                } else {
                    ttp = (this.DxsObjParams.totalVlumn / 6000 - this.newObj.firstWeight) * this.newObj.weightFee + this.newObj.firstFee
                }

            } else if (this.newObj.type == 2) {
                let falg = this.DxsObjParams.totalVlumn / 6000 - this.DxsObjParams.totalWeight > 0 ? this.DxsObjParams.totalVlumn / 6000 : this.DxsObjParams.totalWeight

                if (falg <= this.newObj.firstWeight) {
                    ttp = this.newObj.firstFee
                } else {
                    ttp = (falg - this.newObj.firstWeight) * this.newObj.weightFee + this.newObj.firstFee
                }
            } else {
                ttp = 0
            }
            return ttp
        }
    },
    components: {
        CustomerOrder
    },
    created() {

        this.options = utils.getCountryOption()
        setTimeout(() => {
            utils.getInfoByCache({
                cacheKey: 'orderInfo',
                userId: this.userId
            }).then(res => {
                console.log('----99')
                console.log(res)
                this.orderInfo = res
                this.originData = res
                if (this.orderInfo.orderPdf && this.orderInfo.orderPdf.pdf && this.orderInfo.orderPdf.pdf != '') {
                    this.fileList = [{
                        name: this.orderInfo.orderPdf.pdf,
                        url: this.orderInfo.orderPdf.pdf
                    }]
                }
                this.$nextTick(() => {
                    this.vkgbvm()
                })
                if (this.$route.query.type == 'success') {
                    utils.getInfoByCache({
                        cacheKey: 'addOrderItem',
                        userId: this.userId
                    }).then(res => {
                        let that = this
                        let list = res
                        console.log(that.orderInfo, list)
                        let changeType = that.$route.query.changeType
                        if (changeType) {
                            console.log(changeType - 1)
                            list[0].variationQuantityPurchased = that.$route.query.quantity
                            this.$set(that.orderInfo.items, changeType - 1, list[0])
                        } else {
                            for (let i = 0; i < list.length; i++) {
                                this.orderInfo.items.push(list[i])
                            }
                        }

                    })
                }
            })
        }, 200)



        console.log('orderInfo', this.orderInfo)


    },
    methods: {

        ...mapMutations('common', [
            'addOrderItems',
            'delItems',
            'storageOrderInfo'

        ]),

        openImg(item, ttp,index) {
            console.log(item)
            console.log(ttp)
            console.log(index)
            this.updatPic.orderId = item.orderId;
            this.updatPic.orderSn = ttp.orderSn;
            this.updatPic.itemKey = ttp.itemKey;
            this.updatPic.image = ttp.attributeImage ? ttp.attributeImage : ttp.image;
            this.updatPicShow = true;
            this.updatPicIndex = index;
        },
        handleFileSuccess(item, res, file) {
            console.log(item)
            console.log(file)
            // console.log(file.response.data)
            this.updatPic.image = file.response.data;
        },

        imgCancel() {
            this.updatPic = {
                orderId: '',
                orderSn: '',
                itemKey: '',
                image: '',
            }
            this.updatPicShow = false;
        },
        imgConfirm() {
            var formData = new FormData()
            formData.append('orderId', this.updatPic.orderId)
            formData.append('itemKey', this.updatPic.itemKey)
            formData.append('orderSn', this.updatPic.orderSn)
            formData.append('image', this.updatPic.image)
            galleryApi.updateOrderItemImage(formData)
                .then(res => {
                    if (res.code === 200) {
                        console.log('数据1', res.data)
                        this.$message.success(res.msg)
                        this.orderInfo.items[this.updatPicIndex].image = this.updatPic.image;
                        this.updateCache();
                        this.updatPicShow = false;
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
        },


        vkgbvm() {
            console.log('85245', this.orderInfo.items)
            this.DxsObjParams.totalWeight = 0
            this.DxsObjParams.totalVlumn = 0
            this.orderInfo.items.forEach(p => {
                this.DxsObjParams.totalWeight += (p.weight * p.variationQuantityPurchased)
                this.DxsObjParams.totalVlumn += ((p.packageHeight * p.packageLength * p.packageWidth / 6000) * p.variationQuantityPurchased)
            })
            this.DxsObjParams.totalWeight = this.DxsObjParams.totalWeight.toFixed(2)
            this.DxsObjParams.totalVlumn = this.DxsObjParams.totalVlumn.toFixed(4)
        },
        handleRemove(file, fileList) {
            console.log(file, fileList);
            this.orderInfo.orderPdf.pdf = ""
        },

        handleSuccess(file, fileList) {
            console.log(file, fileList);
            this.orderInfo.orderPdf.pdf = file.data
        },
        handlePreview(file) {
            console.log(file);
        },
        handleExceed(files, fileList) {
            this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${file.name}？`);
        },

        updateCache() {
            utils.updateInfoByCache({
                cacheKey: 'orderInfo',
                userId: this.userId,
                cacheData: JSON.stringify(this.orderInfo)
            })
        },

        //更改订单内一个商品的信息
        changeItem(item, index) {
            this.changeIndex = index
            // this.showProListCopy=true

            this.updateCache()

            this.$router.push({
                path: '/productList',
                query: {
                    area: this.$route.query.area,
                    changeType: index + 1,//更改订单内一个商品的信息
                    quantity: item.variationQuantityPurchased
                }
            })
        },
        deleteItems(index) {
            console.log(index)
            this.$confirm(this.$t('other.a608'), this.$t("other.a142"), {
                confirmButtonText: this.$t('other.a235'),
                cancelButtonText: this.$t('other.a146'),
                type: 'warning'
            }).then(() => {
                this.orderInfo.items.splice(index, 1)
            })
            // this.delItems(index)

        },
        updataItem(list) {
            console.log(list[0])
            if (this.changeIndex !== null) {
                this.changeItems({ index: this.changeIndex, orderItem: list[0] })
                this.changeIndex = null

            } else {
                this.addOrderItems(list[0])
            }




        },
        addItem() {
            console.log(this.showProListCopy)
            this.updateCache()
            // this.showProListCopy=true
            this.$router.push({
                path: '/productList',
                query: {
                    area: this.$route.query.area
                }
            })
        },
        saveItem() {
            this.orderInfo.createTime = null
            this.orderInfo.shipByDate = null
            this.$refs.form.validate((valid) => {
                if (valid) {
                    for (let i = 0; i < this.orderInfo.items.length; i++) {
                        let a = this.orderInfo.items[i].itemKey
                        let b = this.orderInfo.items[i].other
                        this.orderInfo.items[i].itemKey = b
                        this.orderInfo.items[i].other = a
                    }
                    console.log(this.orderInfo)
                    console.log("===1===")
                    this.showLoading()
                    setTimeout(() => {
                        newOrder
                            .updateCustomer(this.orderInfo)
                            .then(res => {
                                if (res.code === 200) {
                                    this.$message.success(this.$t('other.a609'))
                                    setTimeout(() => {
                                        this.back()
                                    }, 200)
                                } else {
                                    for (let i = 0; i < this.orderInfo.items.length; i++) {
                                        let a = this.orderInfo.items[i].itemKey
                                        let b = this.orderInfo.items[i].other
                                        this.orderInfo.items[i].itemKey = b
                                        this.orderInfo.items[i].other = a
                                    }
                                    this.$message.warning(res.msg)
                                }
                            })
                    }, 500)
                } else {
                    this.$message.warning(this.$t('other.a649'))
                    return false;
                }
            });
        },
        back() {
            if (this.$route.query.area) {
                this.$router.push({
                    path: this.$route.query.area
                })
            } else {
                this.$router.push({
                    path: '/pendingoreder'
                })

            }
        },
        reset() {
            this.showLoading()
            setTimeout(() => {
                newOrder
                    .updateOriginal({
                        orderId: this.orderInfo.orderId,
                        userId: this.userId,
                        shopId: this.orderInfo.shopId
                    })
                    .then(res => {
                        if (res.code === 200) {
                            this.$message.success(this.$t('other.a610'))
                            this.storageOrderInfo(this.originData)
                            setTimeout(() => {
                                this.back()
                            }, 200)
                        } else {
                            this.$message.warning(res.msg)
                        }
                    })
            }, 500)

        },
        bvjnf(index) {
            console.log(this.orderInfo.items, index)
            let ttp = this.orderInfo.items[index].variationsCopy.find(item => item.itemKey == this.orderInfo.items[index].itemKey)
            console.log(ttp)
            this.orderInfo.items[index].image = ttp.image
            this.orderInfo.items[index].attributeImage = ttp.image
            this.orderInfo.items[index].variationName = ttp.variationName
            this.orderInfo.items[index].variationSku = ttp.variationSku
            this.orderInfo.items[index].storeItem.cusCode = ttp.cusCode
            console.log(this.orderInfo.items[index])
        },

    }
}

</script>
<style lang="scss" scoped>
.chageOrderInfo {
    font-size: 18px;

    .chageOrderInfo_top {
        display: flex;
        justify-content: space-between;


        .btn {
            display: flex;
            margin-right: 10px;


            .btn_item {
                margin: 0 10px;
            }
        }
    }

    .order_info {
        margin: 10px 0;
    }

    .table {

        .picbox {
            width: 60px;
            height: 60px;
        }
    }
}

.receiptInfo {
    background-color: #fff;
    box-sizing: border-box;

    padding: 20px 5px;
    margin: 5px;

    .desc_title {
        font-size: 18px;
        font-weight: 500;
        display: flex;
        justify-content: space-between;
    }

    .vjhkbnv {
        /deep/ .edit-item {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            color: #9797a1;
            font-size: 14px;
            height: 40px;
            margin-top: 20px;
            border-bottom: 1px solid #e3e3e3
        }

        /deep/ .el-form-item {
            margin-bottom: 0px;
        }

        /deep/ .el-form-item__content {
            border-bottom: 1px solid #000;
        }

        /deep/ .el-input__inner {
            width: 100%;
            border: none !important;
        }

        /deep/ .el-input--mini {
            width: 170px !important;
        }
    }



}
.avatar-uploader {
  position: relative;
}

.avatar-uploader img {
  width: 120px;
  height: 120px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
  border: 1px dashed #66b1ff;
}
</style>